import React, { useState } from "react";
import { Button } from "semantic-ui-react";
import { ConfirmModal } from "ceco-modal";
import graphql from "babel-plugin-relay/macro";
import { toast } from "react-toastify";
import { commitMutation } from "react-relay";
import environment from "../../../environment";
import { useTranslation } from "ceco-polyglot";

export default function RecipeDeleteModal(props) {
  const { trigger, recipeName, recipeId, refetchData } = props;
  const [modalOpen, setModalOpen] = useState(false);
  const [formData, setFormData] = useState();
  const t = useTranslation();

  function deleteRecipe() {
    return new Promise((resolve, reject) => {
      const variables = {
        ...formData,
      };
      commitMutation(environment, {
        mutation: recipeDeleteModalMutation,
        variables,
        onCompleted(response, errors) {
          if (errors) {
            reject(errors);
          }
          resolve(response);
        },
        onError(error) {
          reject(error);
        },
      });
    });
  }

  const onSubmit = async () => {
    deleteRecipe()
      .then((a) => {
        toast.success(t("message.deleted_recipe"));
        setModalOpen(false);
        refetchData();
      })
      .catch((e) => {
        if (Array.isArray(e)) {
          toast.error(e[0].message);
        } else {
          toast.error(e.errors[0].message);
        }
      });
  };
  return (
    <ConfirmModal
      modalOpen={modalOpen}
      title={t("modalTitle.removeRecipe")}
      trigger={React.cloneElement(trigger, {
        onClick: (e) => {
          e.preventDefault();
          setModalOpen(true);

          setFormData({ id: recipeId });
        },
      })}
      onClose={() => setModalOpen(false)}
      showCloseButton={true}
      description={
        <div>
          {t("warning.recipe_remove", {
            recipeName: recipeName,
          })}
        </div>
      }
      renderActions={() => (
        <div>
          <Button
            color="red"
            onClick={() => {
              onSubmit();
            }}
          >
            {t("action.delete")}
          </Button>
          <Button
            color="green"
            onClick={() => {
              setModalOpen(false);
            }}
          >
            {t("action.cancel")}
          </Button>
        </div>
      )}
    />
  );
}
const recipeDeleteModalMutation = graphql`
  mutation RecipeDeleteModalMutation($id: ID!) {
    recipeDelete(input: { id: $id }) {
      deleted
    }
  }
`;
